import { Dispatch } from 'react';
import { get, post, put } from 'communication/httpClient';
import {
  CLEAN_TENDER,
  SAVE_INITIATED,
  SET_TENDER,
  SET_TENDER_LIST,
  SYNC_FAILED,
  SYNC_FINISHED,
  SYNC_INITIATED,
  TENDER_SET_SAVED,
} from './actionTypes';
import { ITender, ITendersAction, ITendersActions } from './types';
import { mergeExceptions } from '../../utils/exceptions';

export const separateProhibitFromAction = (tenderObject): ITender => {
  const tender = JSON.parse(JSON.stringify(tenderObject));

  tender['prohibitActionDefinitions'] = {};

  if (tender.exceptions && tender.exceptions.length > 0) {
    tender.exceptions = tender.exceptions
      .map((exception) => {
        let shouldRemoveException = false;
        const obj = {
          tenderRestrictionsType: exception.tenderRestrictionsType,
        };
        if (exception.definitions && exception.definitions.length > 0) {
          obj['definitions'] = exception.definitions
            .map((definition) => {
              if (definition.ruleId.indexOf('prohibit') > -1) {
                const tenderRestrictionsType =
                  exception.tenderRestrictionsType === 'TenderVoidBlock'
                    ? 'ProhibitVoid'
                    : exception.tenderRestrictionsType;
                tender['prohibitActionDefinitions'][tenderRestrictionsType] = {
                  enabled: true,
                  messageId: definition.messageId,
                  ruleId: definition.ruleId,
                };

                if (exception.definitions.length === 1) {
                  shouldRemoveException = true;
                }

                return null;
              }

              return definition;
            })
            .filter((item) => {
              return item != null;
            });
        }

        if (shouldRemoveException) {
          return null;
        }

        return obj;
      })
      .filter((item) => {
        return item != null;
      });
  }

  return tender;
};

export const getActions = (dispatch: Dispatch<ITendersAction>): ITendersActions => ({
  loadTenders: async () => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const { data, error } = await get(`/api/tenders`);

    if (data) {
      dispatch({
        type: SET_TENDER_LIST,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  loadTender: async (id: string) => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const { data, error } = await get(`/api/tenders/${id}`);

    if (data) {
      dispatch({
        type: SET_TENDER,
        payload: separateProhibitFromAction(data),
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  saveTender: async (tender: ITender, isNew: boolean, onSucces?: (tender: ITender) => void) => {
    dispatch({
      type: SAVE_INITIATED,
    });
    const handler = !isNew ? put : post;
    const url = !isNew ? `/api/tenders/${tender.id}` : '/api/tenders';
    const { error, data } = await handler(url, tender);

    if (!error) {
      const hasFailedRuleIds =
        data && Array.isArray(data.failedRuleIds) && data.failedRuleIds.length > 0;
      const tenderUsed = separateProhibitFromAction(
        hasFailedRuleIds ? mergeExceptions(tender, data.tender) : isNew ? tender : data.tender
      );
      dispatch({
        type: TENDER_SET_SAVED,
        payload: {
          ...data,
          tender: tenderUsed,
        },
      });
      if (onSucces) onSucces(tenderUsed);
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  cleanTender: () => {
    dispatch({
      type: CLEAN_TENDER,
    });
  },
});
